<template>
    <child-form-modal v-model="addChild" v-on:success="reload" :group-id="groupId"/>
</template>

<script>
import ChildFormModal from "../../../modules/Children/organisms/ChildFormModal.vue";
import {eventBus} from "../../../services/EventBus";

export default {
    name: "AddChild",
    components: {
        ChildFormModal,
    },
    data() {
        return {
            addChild: false,
            groupId: null
        }
    },
    methods: {
        init(data) {
            this.groupId = data?.groupId;
            this.addChild = true;
        },
        reload() {
            eventBus.$emit('reloadChildren');
        }
    }
}
</script>
